var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCoffeeSolid = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 11 3 L 11 7 L 13 7 L 13 3 Z M 15 4 L 15 7 L 17 7 L 17 4 Z M 4.875 8 L 5 9.09375 L 6.8125 26.3125 C 6.972656 27.832031 8.285156 29 9.8125 29 L 19.1875 29 C 20.714844 29 22.027344 27.832031 22.1875 26.3125 L 22.65625 22 L 25 22 C 26.644531 22 28 20.644531 28 19 L 28 16 C 28 14.355469 26.644531 13 25 13 L 23.59375 13 L 24 9.09375 L 24.125 8 Z M 7.125 10 L 21.875 10 L 20.1875 26.09375 C 20.132813 26.613281 19.707031 27 19.1875 27 L 9.8125 27 C 9.292969 27 8.867188 26.613281 8.8125 26.09375 Z M 23.375 15 L 25 15 C 25.566406 15 26 15.433594 26 16 L 26 19 C 26 19.566406 25.566406 20 25 20 L 22.84375 20 Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCoffeeSolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/coffee-solid.874af02cb4f7e7c4ffe8631b065d61f9.svg";